import React, { Component } from 'react';

function underscore(str) {
  return str.replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').replace(':', '').replace('(', '').replace(')', '').toLowerCase();
};

export default class FormWizard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {step: 0, finished: false, focused: false};

    this.handleChange     = this.handleChange.bind(this);
    this.handleSubmit     = this.handleSubmit.bind(this);
    this.handleBack       = this.handleBack.bind(this);
    this.validationError  = this.validationError.bind(this);
  }

  t(string) {
    switch (string) {
      case 'next':
      return this.props.lang == "en" ? "Next" : "Dalje"
      break;
      case 'previous':
      return this.props.lang == "en" ? "Previous" : "Natrag"
      break;
      case 'submit':
      return this.props.lang == "en" ? "Submit" : "Završi prijavu"
      break
    }
  }

  componentDidMount() {
    $('input:first').focus()
  }

  componentDidUpdate() {
    let app = this
    // $(".datepicker1").datepicker({ dateFormat: 'dd.mm.yy', changeMonth: true, changeYear: true, yearRange: ((new Date).getFullYear()-80) +':'+ ((new Date).getFullYear() - 17), onSelect: function(){ app.setState({birthday: $(this).val()}) } });
    // $(".datepicker2").datepicker({ dateFormat: 'dd.mm.yy', changeMonth: true, changeYear: true, yearRange: ((new Date).getFullYear()-1) +':'+ ((new Date).getFullYear() + 20), onSelect: function(){ app.setState({document_deadline: $(this).val()}) } });
  }

  handleChange(event) {
    this.setState({focused: false});
    if(event.target.type === "checkbox"){
      let value = this.state[event.target.name] || [];
      if(event.target.checked) {
        // this.setState({[event.target.name]: "true"});
        value.push(event.target.value);
      } else {
        var index = value.indexOf(event.target.value);
        value.splice(index, 1);
        // this.setState({[event.target.name]: null});
      }
      // console.log(value);
      this.setState({[event.target.name]: value});
    } else {
      $(event.target).next().remove();
      if(event.target.files){
        let reader = new FileReader();
        let file = event.target.files[0];
        let target_name = event.target.name + "_data_uri";
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.setState({[target_name]: reader.result});
        }
      } else {
        this.setState({[event.target.name]: event.target.value});
      }
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    event.target.reset();
    if(this.state.step + 1 < this.props.fields.length){
      this.setState({step: this.state.step + 1});
      window.scrollTo(0, 440);
      setTimeout(function(){$('input:first').focus()}, 100);
    } else {
      fetch(this.props.submit_to, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(this.state)
      })
      this.setState({finished: true});
    }
  }

  validationError(event) {
    event.preventDefault();
    $(event.target).next().remove();
    $(event.target).fadeOut("slow");
    $(event.target).fadeIn("slow");
    if (this.state.focused === false){
      $(event.target).focus();
      this.setState({focused: true});
    }
    $(event.target).after("<div class='error'>" + this.props.error_message + "</div>");
    window.scrollTo(0, 440);
  }

  handleBack(event) {
    $('.error').hide()
    this.setState({step: this.state.step - 1});
    window.scrollTo(0, 440);
    setTimeout(function(){$('input:first').focus()}, 100);
  }

  format_hint(string) {
    return string ? <em>({string})</em> : "";
  }

  ////// RENDER //////

  render() {

    const disclamer = this.props.lang == "hr" ?
                      <div className="registration_disclamer">
                        <p>Potpisom ove pristupnice dobrovoljno pristupam Regionalnom industrijskom sindikatu, te ga ovlašćujem da zastupa moje interese iz rada i po osnovi rada i da u moje ime pregovara i zaključuje kolektivne ugovore. Obvezujem se na provedbu članskih obaveza sukladno Statutu RIS-a, kao i drugim aktima donesenim na osnovi Statuta RIS-a.</p>
                        <p>Slanjem pristupnice suglasan/na sam s obradom mojih osobnih podataka u isključivu svrhu članstva u Regionalnom industrijskom sindikatu, a u skladu sa Zakonom o provedbi Opće uredbe o zaštiti podataka ("Narodne novine" br. 42/2018) i u skladu s načelima i procedurama propisanima Općom uredbom o zaštiti podataka (EU 2016/679) o zaštiti pojedinca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka te s njom usklađenim internim aktima Regionalnog industrijskog sindikata.</p>
                      </div> :
                      <div className="registration_disclamer">
                        By completing this application form I give my consent to the Cooperative for Ethical Financing to process my personal data given in this application form for the purpose of acquiring membership in the Cooperative and that I have read and understood the <a href="https://zef.hr/system/document/document_en/27/ZEF_PRIVACY_POLICY.pdf" target="_blank">Privacy Policy</a>.
                      </div>

    const inputs = this.props.fields[this.state.step][0].inputs.map((field, index) =>
      <span key={index}>
        <label><span dangerouslySetInnerHTML={{__html: field.label}}></span>{this.format_hint(field.hint)}</label>
          {(() => {
            switch (field.type) {
              case "textarea":  return <textarea value={this.state[underscore(field.name)]} required={field.required} rows="5" key={underscore(field.name)} name={underscore(field.name)} onChange={this.handleChange} onInvalid={this.validationError} />;
              case "select":    return <span className="custom-dropdown dropdown1"><select className={field.extra_class} required={field.required} value={this.state[underscore(field.name)]} key={underscore(field.name)} name={underscore(field.name)} onChange={this.handleChange} onInvalid={this.validationError}>
                                        <option></option> {
                                          field.collection.map(function (item) {
                                            return <option value={item}>{item}</option>;
                                          })
                                        }</select></span>
              case "time":      return <div className="time_select">
                                        <div className="custom-dropdown dropdown2"><select value={this.state[underscore(field.name)+"(h)"]} key={underscore(field.name)+"(h)"} name={underscore(field.name)+"(h)"} onChange={this.handleChange} onInvalid={this.validationError}>
                                          <option></option>
                                          {Array(24).fill(1).map((el, i) =>
                                            <option>{i}</option>
                                          )}
                                        }</select></div>&nbsp;:&nbsp;
                                        <div className="custom-dropdown dropdown2"><select value={this.state[underscore(field.name)+"(m)"]} key={underscore(field.name)+"(m)"} name={underscore(field.name)+"(m)"} onChange={this.handleChange} onInvalid={this.validationError}>
                                          <option></option>
                                          {Array(4).fill(1).map((el, i) =>
                                            <option>{(i*15).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}</option>
                                          )}
                                        }</select></div></div>
              case "checkboxes": return <div className="checkbox_holder"> {
                                          field.collection.map((item) => {
                                            return <label className="checkbox"><input required={field.required} type="checkbox" defaultChecked={this.state[underscore(field.name)] && this.state[underscore(field.name)].indexOf(item) > -1} value={item} key={underscore(field.name)} name={underscore(field.name)} onChange={this.handleChange} onInvalid={this.validationError}/><span className="checkmark"></span>{item}</label>;
                                          })
                                        }</div>

              case "date":       return <input className={field.extra_class} required={field.required} value={this.state[underscore(field.name)]} type="date" key={underscore(field.name)} name={underscore(field.name)} onChange={this.handleChange} onInvalid={this.validationError} />;
              case "file":       return <input className={field.extra_class} required={field.required} type="file" key={underscore(field.name)} name={underscore(field.name)} onChange={this.handleChange} onInvalid={this.validationError} />;
              default:           return <input className={field.extra_class} required={field.required} value={this.state[underscore(field.name)]} type={field.type} key={underscore(field.name)} name={underscore(field.name)} onChange={this.handleChange} onInvalid={this.validationError} />;
            }
          })()}
      </span>
    );

    const back_button = this.state.step > 0 ? <input className="button left" type="button" value={this.t('previous')} onClick={this.handleBack} /> : "";
    const form = <section className="members-form" style={{paddingTop: '0'}}>
      {this.props.has_disclamer ? disclamer : null}
      <ol className="form-steps">
        {Array(this.props.fields.length).fill(1).map((el, i) =>
          <li className={this.state.step >= i ? "done" : null}><a href="#">{i+1}</a></li>
        )}
      </ol>
      <form onSubmit={this.handleSubmit}>
        <legend>{this.props.fields[this.state.step][0].title}</legend>
        {inputs}
        <div>
          {back_button}
          <input className="button right" type="submit" value={this.state.step + 1 === this.props.fields.length ? this.t('next') : this.t('next')} />
        </div>
      </form>
      </section>

    const message = <section className="gray members-form" dangerouslySetInnerHTML={{__html: this.props.thank_you_message}}></section>

    return this.state.finished ? message : form;
  }

}



// WEBPACK FOOTER //
// app/frontend/components/FormWizard.jsx